import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehiculos-toyota',
  templateUrl: './vehiculos-toyota.component.html',
  styleUrls: ['./vehiculos-toyota.component.css']
})
export class VehiculosToyotaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
